module.exports = __webpack_public_path__ + "img/portfolio-08-03-670x479.5656bc51.jpg";